import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6578d780"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6578d780')) {
      api.createRecord('6578d780', component.options)
    } else {
      api.reload('6578d780', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6578d780", function () {
      api.rerender('6578d780', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/components-wa/funsies/QuestionMarkBlock/index.vue"
export default component.exports